import axios from 'axios';

export const getDefinition = async (form, source) => {
   const response = await axios.get(`/api/formsapi/forms/${form}`);
   return response.data;
}

export const getSessionId = async () => {
   const response = await axios.get(`/api/getSessionId`);
   return response.data.sessionId;
}
